var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[(_vm.systemSettings)?_c('GrantCompanySettingsTable',{staticClass:"mt-8",attrs:{"rows":_vm.grantSettingsRows,"system":_vm.systemSettings},on:{"onSettingsChanged":_vm.onSettingsChanged,"onRowChanged":_vm.onRowChanged}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }